import { Link } from "react-router-dom";
import type { Work } from "@/types";

interface WorkCardProps {
  work: Work;
}

export default function WorkCard({ work }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      data-product-shop
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 animate-fade-up cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={`${work.title} 影视封面`}
          title={`${work.title} - 爱爱网影视推荐`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
          {work.type}
        </span>
        <span className="absolute top-2 right-2 flex items-center gap-0.5 px-2 py-0.5 rounded-full bg-accent-500 text-primary-950 text-xs font-bold">
          <i className="ri-star-fill text-[10px]" />
          {work.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-foreground-950/85 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-white text-xs line-clamp-2">{work.synopsis}</p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {work.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {work.cast.slice(0, 2).join(" · ")}
        </p>
        <div className="mt-2 flex items-center gap-1 flex-wrap">
          <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 text-[10px]">
            {work.genre}
          </span>
          <span className="text-[10px] text-foreground-400">{work.year}</span>
          <span className="text-[10px] text-foreground-400">· {work.region}</span>
        </div>
      </div>
    </Link>
  );
}